import React, { FC } from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';

import type { ReduxState } from 'app/redux/types';

import { BettingContext } from 'app/contexts/betting';
import $betting from 'app/contexts/betting/$interesting-matches';
import { GridSkeletons } from 'app/design-system/components/Skeleton/GridSkeleton';
import { useTranslation } from 'app/lang';

import { hasLiveMatches, onlyLiveMatches, selectSortedSportIds } from '../../selectors';
import { entityLoading } from '../../selectors/entities';
import Sport from '../Sport';

import dictionary from './Content.dictionary.json';

import styles from './Content.module.scss';

type NoDataProps = {
  title: string;
};

type ContentProps = {
  sortedSportIds: List<number>;
  onlyLiveMatches: boolean;
  hasLiveMatches: boolean;
  loading: boolean;
};

const NoData: FC<NoDataProps> = ({ title }) => (<p className={styles.noData}>{title}</p>);

const Content: FC<ContentProps> = ({
  sortedSportIds,
  onlyLiveMatches,
  hasLiveMatches,
  loading,
}) => {
  const { t } = useTranslation();

  const isRequesting = loading && sortedSportIds.size <= 0;

  if (isRequesting) {
    return (
      <GridSkeletons className={styles.skeletonWrapper} />
    );
  }

  if (onlyLiveMatches && !hasLiveMatches) {
    return (
      <NoData title={t(dictionary.noLiveMatch)} />
    );
  }

  return (
    <BettingContext.Provider value={$betting}>
      {sortedSportIds.map((sportId) => (

        <Sport sportId={sportId}
               key={sportId} />
      ))}
    </BettingContext.Provider>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  loading: entityLoading(state),
  onlyLiveMatches: onlyLiveMatches(state),
  hasLiveMatches: hasLiveMatches(state),
  sortedSportIds: selectSortedSportIds(state),
});

export default connect(mapStateToProps)(Content);
